import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import CrossGrayIcon from '../../common/images-new/cross-gray-icon.svg'
import ButtonBlue from "../../components/Button/ButtonBlue";
import { staticFiles } from "../../components/Helpers/Static";
import ShareExport from "../../pages/Community/ShareExport";
import ShowcaseOption from "./ShowcaseOption";
import { Card, BgPostButton } from "../../pages/Theme";
import ButtonHashtag from "../Button/ButtonHashtag";
import { downloadsubmissions } from "../../redux/actions/teaching";

const CROSS_GRAY_ICON = staticFiles.cross;

const ModalStudentExport = ({ show, setShow, data, id }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.export.isLoading);
  const [initialLoad, setinitialLoad] = useState(false);
  const [checkedListPost, setCheckedListPost] = useState([]);
  const [textFilter, setTextFilter] = useState("");
  const [filteredPosts, setFilteredPosts] = useState([]);

  const showHideModal = show
    ? "fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex"
    : "fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden";

  useEffect(() => {
    setFilteredPosts(data);
  }, []);

  useEffect(() => {
    if (data?.length > 0 && initialLoad == false) {
      // setCheckedListPost(myPosts)
      setinitialLoad(true);
    }
    const filteredData = data.filter((postItem) =>
      postItem.user_name.toLowerCase().includes(textFilter.toLowerCase())
    );
    setFilteredPosts(filteredData);
  }, [textFilter, data]);

  function close() {
    setShow(false);
  }

  function addPost(id) {
    const newList = [
      ...checkedListPost,
      ...data.filter((item) => item.id === id),
    ];

    setCheckedListPost(newList);
  }

  function removePost(id) {
    const newList = checkedListPost.filter((item) => item.id !== id);
    setCheckedListPost(newList);
  }

  const handleExportPdf = () => {
    if (checkedListPost.length != 0) {
      let data = "";
      let value = "";
      checkedListPost.map(
        (r, ind) => (
          (value = "," + r.id),
          ind == 0 ? (data += r.id) : (data += value),
          (value = "")
        )
      );
      dispatch(downloadsubmissions(data, id));
    }
    setCheckedListPost([]);
    close();
  };

  const selectAllNone = () => {
    if (
      checkedListPost?.length == filteredPosts?.length &&
      checkedListPost?.length > 0
    ) {
      setCheckedListPost([]);
    }
    if (
      checkedListPost?.length > 0 &&
      checkedListPost?.length != filteredPosts?.length
    ) {
      setCheckedListPost(filteredPosts);
    }
    if (checkedListPost?.length == 0 && filteredPosts?.length > 0) {
      setCheckedListPost(filteredPosts);
    }
  };

  return (
    <div className={showHideModal} onClick={(e) => e.stopPropagation()}>
      <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4 popUpWidth w-3/4">
        <Card className=" bg-white px-4 md:px-8 py-5 my-5 rounded-md filter drop-shadow-md ">
          <div className="flex   justify-between items-center">
            <div className="w-full font-semibold blackColor ">
              Export
            </div>
            <button
              className="text-gray-600 hover:text-black text-xl font-bold"
              onClick={close}
            >
              ×
            </button>
          </div>
          <div className="my-5 overflow-x-auto ">
            <div className="flex flex-col ">
              <div
                className=" flex items-center w-full justify-end cursor-pointer"
                onClick={selectAllNone}
              >
                <BgPostButton className="select-allnone  w-max">
                  {checkedListPost?.length > 0 &&
                  checkedListPost?.length == filteredPosts?.length
                    ? "Unselect All"
                    : "Select All"}
                </BgPostButton>
              </div>
              <div className="flex flex-row mb-2 items-center mt-4">
                <label className="text-sm mr-5 whitespace-nowrap font-bold">
                  Search student
                </label>
                <input
                  className="h-10 w-full bg-gray-100 text-black rounded-lg pl-4 pr-4"
                  type="search"
                  placeholder="type to search..."
                  value={textFilter}
                  onChange={(e) => setTextFilter(e.target.value)}
                />
              </div>
              <div className="flex flex-col h-80 px-5 space-y-3 my-5 overflow-y-scroll w-full">
                {filteredPosts?.map((post, index) => (
                  <ShareExport
                    key={index}
                    idx={index}
                    item={post}
                    add={addPost}
                    remove={removePost}
                    isShow={checkedListPost.filter((r) => r.id == post.id)}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-5 justify-center">
            {isLoading ? (
              <div className="w-full flex justify-center">
                <p className="font-semibold">Loading...</p>
              </div>
            ) : (
              <>
                <ButtonBlue
                  title="Export Assignments"
                  onClick={() => {
                    handleExportPdf();
                  }}
                />
              </>
            )}
          </div>
        </Card>
      </section>
    </div>
  );
};

export default ModalStudentExport;
